import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';
import fileDownload from 'js-file-download';

export function generateReportSuccess() {
  return { type: types.GENERATE_REPORT_SUCCESS };
}

export function generateSiteMorByMonth(siteId, startDate, endDate, fileName) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url =
      baseApi +
      'readings/water/sites/' +
      parseInt(siteId, 10) +
      '/' +
      startDate +
      '/' +
      endDate;
    return axios
      .get(url, {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/pdf',
        },
      })
      .then((response) => {
        const suggestedName = response.headers['X-Suggested-Filename'];
        fileDownload(
          response.data,
          suggestedName || fileName || 'monthly-water.pdf'
        );
        dispatch(generateReportSuccess());
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function generateSiteDNRbyMonth(siteId, startDate, endDate, fileName) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url =
      baseApi +
      'readings/waste/sites/' +
      parseInt(siteId, 10) +
      '/' +
      startDate +
      '/' +
      endDate;
    return axios
      .get(url, {
        responseType: 'blob',
      })
      .then((response) => {
        const suggestedName = response.headers['X-Suggested-Filename'];
        fileDownload(
          response.data,
          suggestedName || fileName || 'monthly-DNR.xls'
        );
        dispatch(generateReportSuccess());
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function generateSiteBillingReportByMonth(
  siteId,
  startDate,
  endDate,
  fileName
) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url =
      baseApi +
      'sites/' +
      parseInt(siteId, 10) +
      '/billing-items/' +
      startDate +
      '/' +
      endDate;
    return axios
      .get(url, {
        responseType: 'blob',
      })
      .then((response) => {
        const suggestedName = response.headers['X-Suggested-Filename'];
        fileDownload(
          response.data,
          suggestedName || fileName || 'monthly-billing.xls'
        );
        dispatch(generateReportSuccess());
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/reportActions.js